import {
  RestaurantModifierDTO,
  RestaurantModifierGroupDTO,
  RestaurantModifierRequest,
} from '../../../../types/restaurant/RestaurantCatalogExtensionTypes';
import { ModifierForm } from './types';

export const formatMenuConfigurationMoney = (value: number) =>
  new Intl.NumberFormat('es-SV', {
    style: 'currency',
    currency: 'USD',
  }).format(Number(value || 0));

export const normalizeMenuConfigurationModifiers = (
  value: unknown
): RestaurantModifierDTO[] => {
  if (Array.isArray(value)) return value;

  if (value && typeof value === 'object') {
    const content = (value as { content?: unknown }).content;
    if (Array.isArray(content)) return content;
  }

  return [];
};

export const normalizeMenuConfigurationModifierGroups = (
  value: unknown
): RestaurantModifierGroupDTO[] => {
  if (!Array.isArray(value)) return [];

  return value
    .filter(
      (group): group is Record<string, unknown> =>
        group !== null && typeof group === 'object'
    )
    .map((group) => ({
      ...(group as unknown as RestaurantModifierGroupDTO),
      modifiers: normalizeMenuConfigurationModifiers(group.modifiers),
    }));
};

export const modifierDtoToForm = (
  modifier: RestaurantModifierDTO
): ModifierForm => ({
  id: modifier.id,
  groupId: modifier.groupId,
  name: modifier.name,
  priceAdjustment: Number(modifier.priceAdjustment),
  deductRawMaterial:
    modifier.rawMaterialId != null ||
    modifier.consumptionQuantity != null ||
    modifier.consumptionUnitId != null,
  rawMaterialId: modifier.rawMaterialId ?? '',
  consumptionQuantity: modifier.consumptionQuantity ?? '',
  consumptionUnitId: modifier.consumptionUnitId ?? '',
  displayOrder: modifier.displayOrder,
  active: modifier.active,
});

export const modifierInventoryIsValid = (form: ModifierForm) =>
  !form.deductRawMaterial ||
  (form.rawMaterialId !== '' &&
    form.consumptionUnitId !== '' &&
    form.consumptionQuantity !== '' &&
    Number.isFinite(Number(form.consumptionQuantity)) &&
    Number(form.consumptionQuantity) > 0);

export const modifierFormToRequest = (
  form: ModifierForm
): RestaurantModifierRequest => ({
  groupId: form.groupId,
  name: form.name.trim(),
  priceAdjustment: form.priceAdjustment,
  rawMaterialId: form.deductRawMaterial ? Number(form.rawMaterialId) : null,
  consumptionQuantity: form.deductRawMaterial
    ? Number(form.consumptionQuantity)
    : null,
  consumptionUnitId: form.deductRawMaterial
    ? Number(form.consumptionUnitId)
    : null,
  displayOrder: form.displayOrder,
  active: form.active,
});
